(function () {
  'use strict';

  var KEY = '2lane:recently-viewed';
  var MAX = 12;

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      if (!Array.isArray(raw)) return [];
      // Handles only: strings with no whitespace or URL delimiters. Not
      // ASCII-only — the catalogue has handles such as roadsofa™-seat-…,
      // and an ASCII pattern silently dropped those products on every read.
      return raw.filter(function (h) {
        return typeof h === 'string' && /^[^\s\/?#%\\]{1,255}$/.test(h);
      });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
    }
  }

  function record(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }

  function money(cents, format) {
    if (window.TwoLaneCart && window.TwoLaneCart.formatMoney) return window.TwoLaneCart.formatMoney(cents);
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function card(product, moneyFormat) {
    var url = '/products/' + product.handle;

    var root = document.createElement('div');
    root.className = 'product-card';

    var wrap = document.createElement('div');
    wrap.className = 'product-card__img-wrap';

    var imgLink = document.createElement('a');
    imgLink.className = 'product-card__img-link';
    imgLink.href = url;
    imgLink.tabIndex = -1;
    imgLink.setAttribute('aria-hidden', 'true');

    if (product.featured_image) {
      var img = document.createElement('img');
      img.className = 'product-card__img';
      // Shopify CDN URL from the product JSON — sized down for the grid.
      img.src = product.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_400x$1');
      img.alt = product.title;
      img.loading = 'lazy';
      imgLink.appendChild(img);
    }
    wrap.appendChild(imgLink);
    root.appendChild(wrap);

    var info = document.createElement('div');
    info.className = 'product-card__info';

    var name = document.createElement('a');
    name.className = 'product-card__name';
    name.href = url;
    name.textContent = product.title;          // never innerHTML
    info.appendChild(name);

    var row = document.createElement('div');
    row.className = 'product-card__price-row';

    var price = document.createElement('p');
    price.className = 'product-card__price';
    var strong = document.createElement('strong');
    strong.textContent = money(product.price, moneyFormat);
    if (product.price_varies) {
      var from = document.createElement('span');
      from.className = 'product-card__from';
      from.textContent = 'From';
      price.appendChild(from);
      price.appendChild(document.createTextNode(' '));
    }
    price.appendChild(strong);
    row.appendChild(price);

    info.appendChild(row);
    root.appendChild(info);
    return root;
  }

  function render(section, grid, handles, moneyFormat) {
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (r.ok) return r.json();
          // 404 means deleted or unpublished. Any other failure may be
          // transient and must not cost the shopper their history.
          return r.status === 404 ? false : null;
        })
        .catch(function () { return null; });
    })).then(function (products) {
      // Prune only the handles that 404'd, from the full stored list.
      // Rewriting storage from the fetched products instead would drop the
      // product recorded on this very page (it is excluded from `handles`)
      // and everything past `limit`, freezing the list on the first product
      // ever viewed.
      var dead = handles.filter(function (h, i) { return products[i] === false; });
      if (dead.length) {
        write(read().filter(function (h) { return dead.indexOf(h) === -1; }));
      }

      var live = products.filter(Boolean);
      if (!live.length) return;

      live.forEach(function (p) { grid.appendChild(card(p, moneyFormat)); });
      section.hidden = false;
    });
  }

  // The handle of the product this page is showing. Recorded once at
  // startup: init() runs again when the theme editor re-renders the
  // section, and recording there would only re-stamp the same handle.
  var currentHandle = null;

  // `root` scopes the lookup to one re-rendered section; with nothing
  // passed it searches the whole document, as the page load does.
  function init(root) {
    var scope = root && root.querySelector ? root : document;
    var section = scope.querySelector('[data-recently-viewed]');
    if (!section) return;

    // Already wired — a section:load for some other section.
    if (section.rvInit) return;
    section.rvInit = true;

    var grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    var limit = parseInt(section.getAttribute('data-limit'), 10) || 5;
    var moneyFormat = section.getAttribute('data-money-format') || '${{amount}}';

    var handles = read().filter(function (h) { return h !== currentHandle; }).slice(0, limit);
    if (!handles.length) return;

    // The strip sits at the foot of the page, so fetching up to `limit`
    // full product documents at DOMContentLoaded would compete with
    // above-the-fold loading for something most visitors never reach.
    // Wait until it is near the viewport, as related products does in
    // main.js. The section is display:none while hidden and never
    // intersects, so observe its Shopify wrapper: a zero-height block
    // still reports intersection.
    var target = section.closest('.shopify-section') || section.parentElement;
    if (!target || !('IntersectionObserver' in window)) {
      render(section, grid, handles, moneyFormat);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      var near = entries.some(function (entry) { return entry.isIntersecting; });
      if (!near) return;
      observer.disconnect();
      render(section, grid, handles, moneyFormat);
    }, { rootMargin: '400px' });

    observer.observe(target);
    section.rvObserver = observer;
  }

  function start() {
    // Record the current product before rendering, so the product
    // you're looking at is excluded from its own "recently viewed".
    currentHandle = document.body.getAttribute('data-product-handle');
    if (currentHandle) record(currentHandle);
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) init(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var old = e.target.querySelector && e.target.querySelector('[data-recently-viewed]');
    if (old && old.rvObserver) old.rvObserver.disconnect();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
